<div class="main-content">
  <div class="container-fluid">
    <div class="card">
<!--       <div class="card-header card-header-primary card-header-icon">
        <div class="card-icon">
          <i class="material-icons">chrome_reader_mode</i>
        </div>
        <h4 class="card-title">Inventory History</h4>
      </div> -->
      <div class="card-body">

        <!--<loading *ngIf="loading"></loading>-->
        <ngx-skeleton-loader *ngIf="loading" count="10" appearance="line" animation="pulse"></ngx-skeleton-loader>
        <dinamic-table
          *ngIf="!loading"
          [id]="'historyTable'"
          [data]="data"
          [dbname]="'tableinventoryhistoryopti'"
          [campoBusqueda]="search"
          [perPage]="perpage"
          [page]="page"
          [total_items_count]="totalItems"
          [total_pages]="totalPaginas"
          (action_button)="action($event)"
          (rightClickAction)="handleRightClick($event)" 
          (newConfig)="updateConfig($event)"
          (buscar)="getData($event, false)"
          [config]="options"
          [columnfilters]="filtros"
        ></dinamic-table>

      <!--   <hr style="border: 1px solid purple; margin-bottom: 50px;" *ngIf="showDetails"> -->
<!-- 
        <div *ngIf="showDetails">
          <div class="row">
            <div class="col-6">
              <mat-form-field>
                <textarea name="internalComments" rows="5" matInput placeholder="Internal Comments" [(ngModel)]="internalComments" readonly></textarea>
              </mat-form-field>
            </div>
            <div class="col-6">
              <mat-form-field>
                <textarea name="systemComments" rows="5" matInput placeholder="Inventory System Comments" [(ngModel)]="systemComments" readonly></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="row scrollClass" *ngIf="showSpecs" #childScrollElement (wheel)="stopPropagation($event)">

            <div class="col-md-12">
              <div class="alert alert-primary" role="alert">
                EPS PXE Information
              </div>
            </div>
            <div class="col-md-12">
              <div class="card card-body border" *ngFor="let s of system; let i = index">

                  <label class="bmd-label-floating">
                    <b>
                      System Information:
                    </b>
                   <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(s, 'system')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="systemManufacturer{{i+1}}" class="form-control fctrl" [(ngModel)]="s.manufacturer" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="systemModel{{i+1}}" class="form-control fctrl" [(ngModel)]="s.model" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="systemSerialNumber{{i+1}}" class="form-control fctrl" [(ngModel)]="s.serialnumber" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number New</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="systemSerialNumberNew{{i+1}}" class="form-control fctrl" [value]="s.serialnumberNew !== null ? s.serialnumberNew : s.serialnumber" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">SKU</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="systemSKU{{i+1}}" class="form-control fctrl" [(ngModel)]="s.sku" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Processor Information</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="systemField2{{i+1}}" class="form-control fctrl" [(ngModel)]="s.field2" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Memory Information</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="systemField3{{i+1}}" class="form-control fctrl" [(ngModel)]="s.field3" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">PO and Line#</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="poline{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="poline"
                        [readonly]="true"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">MDM</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="mdm{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="mdm"
                        [readonly]="true"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Computrace</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="computrace{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="computrace"
                        [readonly]="true"
                      />
                    </div>
                  </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="card card-body border" *ngFor="let hdd of hdds; let i = index">

                  <label class="bmd-label-floating">
                    <b>
                      HDD #{{i+1}} Information:
                    </b>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(hdd, 'hdd')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddManufacturer{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddManufacturer" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddModel{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddModel" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddSerialnumber{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddSerialnumber" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Capacity</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddCapacity{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddCapacity" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Block Size</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddBlocksize{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddBlocksize" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">RPM</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddRpm{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddRpm" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Form Factor</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddFormfactor{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddFormfactor" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Device Type</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddDevicetype{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddDevicetype" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Health Score</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddHealthscore{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddHealthscore" [readonly] = "disabled">
                      <input type="text" name="hddHealthscore{{i+1}}" class="form-control fctrl" value = "90%+" *ngIf="hdd.hddGrade === 'Grade A' || hdd.hddGrade === 'GRADE A' || hdd.hddGrade === 'Grade A-' || hdd.hddGrade === 'GRADE A-'">
                      <input type="text" name="hddHealthscore{{i+1}}" class="form-control fctrl" value = "80%+" *ngIf="hdd.hddGrade === 'Grade B' || hdd.hddGrade === 'GRADE B' || hdd.hddGrade === 'Grade B-' || hdd.hddGrade === 'GRADE B-'">
                      <input type="text" name="hddHealthscore{{i+1}}" class="form-control fctrl" value = "70%+" *ngIf="hdd.hddGrade === 'Grade C' || hdd.hddGrade === 'GRADE C' || hdd.hddGrade === 'Grade C-' || hdd.hddGrade === 'GRADE C-'">
                      <input type="text" name="hddHealthscore{{i+1}}" class="form-control fctrl" value = "60%+" *ngIf="hdd.hddGrade === 'Grade D' || hdd.hddGrade === 'GRADE D' || hdd.hddGrade === 'Grade D-' || hdd.hddGrade === 'GRADE D-'">
                      <input type="text" name="hddHealthscore{{i+1}}" class="form-control fctrl" value = "1%+" *ngIf="hdd.hddGrade === 'Grade E' || hdd.hddGrade === 'GRADE E'">
                      <input type="text" name="hddHealthscore{{i+1}}" class="form-control fctrl" value = "0%" *ngIf="hdd.hddGrade === 'Grade FAIL' || hdd.hddGrade === 'GRADE FAIL'">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Grade</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddGrade{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddGrade" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Reallocated Sectors</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddReallocatedsectors{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddReallocatedsectors" [readonly] = "disabled">
                      <input type="text" name="hddHealthscore{{i+1}}" class="form-control fctrl" value = "0" *ngIf="hdd.hddGrade === 'Grade A' || hdd.hddGrade === 'GRADE A' || hdd.hddGrade === 'Grade B' || hdd.hddGrade === 'GRADE B' || hdd.hddGrade === 'Grade C' || hdd.hddGrade === 'GRADE C' || hdd.hddGrade === 'Grade D' || hdd.hddGrade === 'GRADE D'">

                      <input type="text" name="hddHealthscore{{i+1}}" class="form-control fctrl" value = "5 MAX" *ngIf="hdd.hddGrade === 'Grade A-' || hdd.hddGrade === 'GRADE A-' || hdd.hddGrade === 'Grade B-' || hdd.hddGrade === 'GRADE B-' || hdd.hddGrade === 'Grade C-' || hdd.hddGrade === 'GRADE C-' || hdd.hddGrade === 'Grade D-' || hdd.hddGrade === 'GRADE D-'">

                      <input type="text" name="hddHealthscore{{i+1}}" class="form-control fctrl" value = "50 MAX" *ngIf="hdd.hddGrade === 'Grade E' || hdd.hddGrade === 'GRADE E'">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Power On Hours</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddPoweronhours{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddPoweronhours" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure Method</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddErasuremethod{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddErasuremethod" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure Results</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddErasureresults{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddErasureresults" [readonly] = "disabled" style="font-size: 20px; font-weight: 900;"
                      [ngClass]="{'color-green': hdd.hddErasureresults === 'PASSED', 'color-orange': hdd.hddErasureresults === 'PARTIAL',
                      'color-red': hdd.hddErasureresults === 'FAILED',
                      'color-red-d': hdd.hddErasureresults === 'DESTROYED',
                      'color-red-r': hdd.hddErasureresults === 'REMOVED'}">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc" *ngIf="hdd.isRemoved === '1' || hdd.isDestroyed === '1'">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure Results (Before)</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="statusAnterior{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.statusAnterior" readonly style="font-size: 20px; font-weight: 900;"
                      [ngClass]="{'color-green': hdd.statusAnterior === 'PASSED', 'color-orange': hdd.statusAnterior === 'PARTIAL',
                      'color-red': hdd.statusAnterior === 'FAILED',
                      'color-red-d': hdd.statusAnterior === 'DESTROYED',
                      'color-red-r': hdd.statusAnterior === 'REMOVED'}">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure Start Date</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddErasurestartdate{{i+1}}" class="form-control fctrl" [readonly] = "disabled" [value]=" hdd.hddErasurestartdate | date:'MM/dd/yyyy'">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure Start Time</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddErasurestarttime{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddErasurestarttime" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure End Date</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddErasureenddate{{i+1}}" class="form-control fctrl" [readonly] = "disabled" [value]=" hdd.hddErasureenddate | date:'MM/dd/yyyy'">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure End Time</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddErasureendtime{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddErasureendtime" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc" *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '1'">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Destruction Date</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="destructionDate{{i+1}}" class="form-control fctrl"  [readonly] = "disabled" [value]="hdd.destructionDate | date:'MM/dd/yyyy'">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc" *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '1'">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Destruction Status</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="destructionStatus{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.destructionStatus" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc" *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '1'">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Representative</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="userRemoved{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.userRemoved" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc" *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '0'">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Drive Removed On</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="removedDate{{i+1}}" class="form-control fctrl"  [readonly] = "disabled" [value]="hdd.removedDate | date:'MM/dd/yyyy'">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc" *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '0'">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Representative</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="userRemoved{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.userRemoved" [readonly] = "disabled">
                    </div>
                  </div>
                 <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">PO</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddPo{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddPo" [readonly] = "disabled">
                    </div>
                  </div>

              </div>
            </div>

            <div class="col-md-12">
              <div class="card card-body border" *ngFor="let cpu of cpus; let i = index">

                  <label class="bmd-label-floating">
                    <b>
                      CPU #{{i+1}} Information:
                    </b>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(cpu, 'cpu')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="cpuManufacturer{{i+1}}" class="form-control fctrl" [(ngModel)]="cpu.manufacturer" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="cpuModel{{i+1}}" class="form-control fctrl" [(ngModel)]="cpu.model" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="cpuSerialNumber{{i+1}}" class="form-control fctrl" [(ngModel)]="cpu.serialnumber" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Processor Speed</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="cpuField1{{i+1}}" class="form-control fctrl" [(ngModel)]="cpu.field1" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Processor Cores</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="cpuField2{{i+1}}" class="form-control fctrl" [(ngModel)]="cpu.field2" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Processor Type</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="cpuField3{{i+1}}" class="form-control fctrl" [(ngModel)]="cpu.field3" [readonly] = "disabled">
                    </div>
                  </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="card card-body border" *ngFor="let memory of memories; let i = index">

                  <label class="bmd-label-floating">
                    <b>
                      Memory #{{i+1}} Information:
                    </b>
                   <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(memory, 'memory')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="memoryManufacturer{{i+1}}" class="form-control fctrl" [(ngModel)]="memory.manufacturer" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="memoryModel{{i+1}}" class="form-control fctrl" [(ngModel)]="memory.model" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="memorySerialNumber{{i+1}}" class="form-control fctrl" [(ngModel)]="memory.serialnumber" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Memory Size</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="memoryField1{{i+1}}" class="form-control fctrl" [(ngModel)]="memory.field1" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Memory Speed</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="memoryField2{{i+1}}" class="form-control fctrl" [(ngModel)]="memory.field2" [readonly] = "disabled">
                    </div>
                  </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="card card-body border" *ngFor="let t of testing; let i = index">

                  <label class="bmd-label-floating">
                    <b>
                      Testing #{{i+1}} Information:
                    </b>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(t, 'testing')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="testingSerialnumber{{i+1}}" class="form-control fctrl" [(ngModel)]="t.serialnumber" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Profile</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="testingProfile{{i+1}}" class="form-control fctrl" [(ngModel)]="t.profile" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">CPU</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="testingCPU{{i+1}}" class="form-control fctrl" [(ngModel)]="t.cpu" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Memory</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="testingMemory{{i+1}}" class="form-control fctrl" [(ngModel)]="t.memory" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="testingBattery{{i+1}}" class="form-control fctrl" [(ngModel)]="t.battery" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Missing Parts</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="testingField1{{i+1}}" class="form-control fctrl" [(ngModel)]="t.field1" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Case Condition</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="testingField2{{i+1}}" class="form-control fctrl" [(ngModel)]="t.field2" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Screen Condition</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="testingField3{{i+1}}" class="form-control fctrl" [(ngModel)]="t.field3" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Display Resolution</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="testingDisplayResolution{{i+1}}" class="form-control fctrl" [(ngModel)]="t.displayResolution" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Optical Device</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="testingOpticalDevice{{i+1}}" class="form-control fctrl" [(ngModel)]="t.opticalDevice" [readonly] = "disabled">
                    </div>
                  </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="card card-body border" *ngFor="let battery of batteries; let i = index">

                  <label class="bmd-label-floating">
                    <b>
                      Battery #{{i+1}} Information:
                    </b>
                   <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(battery, 'battery')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="batteryManufacturer{{i+1}}" class="form-control fctrl" [(ngModel)]="battery.manufacturer" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="batteryModel{{i+1}}" class="form-control fctrl" [(ngModel)]="battery.model" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="batterySerialNumber{{i+1}}" class="form-control fctrl" [(ngModel)]="battery.serialnumber" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery Chemistry</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="batteryField1{{i+1}}" class="form-control fctrl" [(ngModel)]="battery.field1" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery Capacity</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="batteryField3{{i+1}}" class="form-control fctrl" [(ngModel)]="battery.field3" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery Full Charge</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="batteryField4{{i+1}}" class="form-control fctrl" [(ngModel)]="battery.field4" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery Life</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="batteryField5{{i+1}}" class="form-control fctrl" [(ngModel)]="battery.field5" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery Drain Test Results</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="batteryField7{{i+1}}" class="form-control fctrl" [(ngModel)]="battery.field7" [readonly] = "disabled">
                    </div>
                  </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="card card-body border" *ngFor="let component of components; let i = index">

                  <label class="bmd-label-floating">
                    <b>
                      Component #{{i+1}} Information:
                    </b>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(component, 'component')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="componentManufacturer{{i+1}}" class="form-control fctrl" [(ngModel)]="component.componentmanufacturer" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="componentModel{{i+1}}" class="form-control fctrl" [(ngModel)]="component.componentmodel" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="componentSerialNumber{{i+1}}" class="form-control fctrl" [(ngModel)]="component.componentserialnumber" [readonly] = "disabled">
                    </div>
                  </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="card card-body border" *ngFor="let network of networks; let i = index">

                  <label class="bmd-label-floating">
                    <b>
                      Network Adapter #{{i+1}} Information:
                    </b>
                    -<button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(network, 'network')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Adapter</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="networkAdapter{{i+1}}" class="form-control fctrl" [(ngModel)]="network.networkadapter" [readonly] = "disabled">
                    </div>
                  </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="card card-body border" *ngFor="let v of video; let i = index">

                  <label class="bmd-label-floating">
                    <b>
                      Video Adapter #{{i+1}} Information:
                    </b>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(v, 'video')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Adapter</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="videoAdapter{{i+1}}" class="form-control fctrl" [(ngModel)]="v.videoadapter" [readonly] = "disabled">
                    </div>
                  </div>
              </div>
            </div>
            
          </div>
          <div class="row scrollClass" *ngIf="showSpecsWorkflow">

            <div class="col-md-12">
              <div class="alert alert-primary" role="alert">
                Workflow Information
              </div>
            </div>
            <div class="col-md-12">
              <div class="card card-body border">
                <div class="row" style="border-top: 1px solid #ccc" *ngFor="let w of workflow; let impar = odd; let par = even">
                  <div class="col-md-12 bg-light border" *ngIf="par">
                    <p style="margin-top: 6px">{{w}}</p>
                  </div>
                  <div class="col-md-12 border" *ngIf="impar">
                    <p style="margin-top: 6px">{{w}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

      </div>
    </div>
  </div>
</div>
<div
  class="modal fade"
  id="modalLogs"
  tabindex="-1"
  role="dialog"
  data-keyboard="false"
>
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <mat-tab-group
          class="mat-typography"
          [(selectedIndex)]="selectedTabIndex"
        >
          <mat-tab *ngIf="showSpecsTree">
            <ng-template mat-tab-label>
              <mat-icon style="margin-right: 8px">account_tree</mat-icon>
              Tree Information
            </ng-template>
            <div
              class="row scrollClass"
              *ngIf="showSpecsTree"
              (wheel)="stopPropagation($event)"
            >
              <div class="col-md-12">
                <div class="mt-4">
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-12 border">
                      <p style="margin-top: 6px">
                        <b>{{ specsTree.masterCategory }}</b>
                      </p>
                    </div>
                  </div>
                  <div
                    class="row"
                    style="border-top: 1px solid #ccc"
                    *ngFor="let s of specsTree.children"
                  >
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">{{ s.spec }}</p>
                    </div>
                    <div class="col-md-6 border">
                      <p style="margin-top: 6px">{{ s.value }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab *ngIf="showSpecs">
            <ng-template mat-tab-label>
              <mat-icon style="margin-right: 8px">insert_drive_file</mat-icon>
              EPS Specs
            </ng-template>
            <div
              class="row scrollClass"
              *ngIf="showSpecs"
              #childScrollElement
              (wheel)="stopPropagation($event)"
            >
              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngFor="let s of system; let i = index"
                >
                  <label class="bmd-label-floating">
                    <b> System Information: </b>
                    <!--<button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(s, 'system')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>-->
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemManufacturer{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="s.manufacturer"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemModel{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="s.model"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemSerialNumber{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="s.serialnumber"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number New</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemSerialNumberNew{{ i + 1 }}"
                        class="form-control fctrl"
                        [value]="
                          s.serialnumberNew !== null
                            ? s.serialnumberNew
                            : s.serialnumber
                        "
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">SKU</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemSKU{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="s.sku"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Processor Information</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemField2{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="s.field2"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Memory Information</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemField3{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="s.field3"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">PO and Line#</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="poline{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="poline"
                        [readonly]="true"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">PO and Batch#</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="batchline"
                        class="form-control fctrl"
                        [(ngModel)]="batchline"
                        [readonly]="true"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">MDM</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="mdm{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="mdm"
                        [readonly]="true"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Computrace</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="computrace{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="computrace"
                        [readonly]="true"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngFor="let hdd of hdds; let i = index"
                >
                  <label class="bmd-label-floating">
                    <b> HDD #{{ i + 1 }} Information: </b>
                    <!--<button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(hdd, 'hdd')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>-->
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddManufacturer{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.hddManufacturer"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddModel{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.hddModel"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddSerialnumber{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.hddSerialnumber"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Capacity</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddCapacity{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.hddCapacity"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Block Size</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddBlocksize{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.hddBlocksize"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">RPM</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddRpm{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.hddRpm"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Form Factor</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddFormfactor{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.hddFormfactor"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Device Type</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddDevicetype{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.hddDevicetype"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Health Score</p>
                    </div>
                    <div class="col-md-6 border">
                      <!--<input type="text" name="hddHealthscore{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddHealthscore" [readonly] = "disabled">-->
                      <input
                        type="text"
                        name="hddHealthscore{{ i + 1 }}"
                        class="form-control fctrl"
                        value="90%+"
                        *ngIf="
                          hdd.hddGrade === 'Grade A' ||
                          hdd.hddGrade === 'GRADE A' ||
                          hdd.hddGrade === 'Grade A-' ||
                          hdd.hddGrade === 'GRADE A-'
                        "
                        readonly
                      />
                      <input
                        type="text"
                        name="hddHealthscore{{ i + 1 }}"
                        class="form-control fctrl"
                        value="80%+"
                        *ngIf="
                          hdd.hddGrade === 'Grade B' ||
                          hdd.hddGrade === 'GRADE B' ||
                          hdd.hddGrade === 'Grade B-' ||
                          hdd.hddGrade === 'GRADE B-'
                        "
                        readonly
                      />
                      <input
                        type="text"
                        name="hddHealthscore{{ i + 1 }}"
                        class="form-control fctrl"
                        value="70%+"
                        *ngIf="
                          hdd.hddGrade === 'Grade C' ||
                          hdd.hddGrade === 'GRADE C' ||
                          hdd.hddGrade === 'Grade C-' ||
                          hdd.hddGrade === 'GRADE C-'
                        "
                        readonly

                      />
                      <input
                        type="text"
                        name="hddHealthscore{{ i + 1 }}"
                        class="form-control fctrl"
                        value="60%+"
                        *ngIf="
                          hdd.hddGrade === 'Grade D' ||
                          hdd.hddGrade === 'GRADE D' ||
                          hdd.hddGrade === 'Grade D-' ||
                          hdd.hddGrade === 'GRADE D-'
                        "
                        readonly

                      />
                      <input
                        type="text"
                        name="hddHealthscore{{ i + 1 }}"
                        class="form-control fctrl"
                        value="1%+"
                        *ngIf="
                          hdd.hddGrade === 'Grade E' ||
                          hdd.hddGrade === 'GRADE E'
                        "
                        readonly

                      />
                      <input
                        type="text"
                        name="hddHealthscore{{ i + 1 }}"
                        class="form-control fctrl"
                        value="0%"
                        *ngIf="
                          hdd.hddGrade === 'Grade FAIL' ||
                          hdd.hddGrade === 'GRADE FAIL'
                        "
                        readonly

                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Grade</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddGrade{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.hddGrade"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Reallocated Sectors</p>
                    </div>
                    <div class="col-md-6 border">
                      <!--<input type="text" name="hddReallocatedsectors{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddReallocatedsectors" [readonly] = "disabled">-->
                      <input
                        type="text"
                        name="hddHealthscore{{ i + 1 }}"
                        class="form-control fctrl"
                        value="0"
                        *ngIf="
                          hdd.hddGrade === 'Grade A' ||
                          hdd.hddGrade === 'GRADE A' ||
                          hdd.hddGrade === 'Grade B' ||
                          hdd.hddGrade === 'GRADE B' ||
                          hdd.hddGrade === 'Grade C' ||
                          hdd.hddGrade === 'GRADE C' ||
                          hdd.hddGrade === 'Grade D' ||
                          hdd.hddGrade === 'GRADE D'
                        "
                      />

                      <input
                        type="text"
                        name="hddHealthscore{{ i + 1 }}"
                        class="form-control fctrl"
                        value="5 MAX"
                        *ngIf="
                          hdd.hddGrade === 'Grade A-' ||
                          hdd.hddGrade === 'GRADE A-' ||
                          hdd.hddGrade === 'Grade B-' ||
                          hdd.hddGrade === 'GRADE B-' ||
                          hdd.hddGrade === 'Grade C-' ||
                          hdd.hddGrade === 'GRADE C-' ||
                          hdd.hddGrade === 'Grade D-' ||
                          hdd.hddGrade === 'GRADE D-'
                        "
                      />

                      <input
                        type="text"
                        name="hddHealthscore{{ i + 1 }}"
                        class="form-control fctrl"
                        value="50 MAX"
                        *ngIf="
                          hdd.hddGrade === 'Grade E' ||
                          hdd.hddGrade === 'GRADE E'
                        "
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Power On Hours</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddPoweronhours{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.hddPoweronhours"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure Method</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddErasuremethod{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.hddErasuremethod"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure Results</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddErasureresults{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.hddErasureresults"
                        [readonly]="disabled"
                        style="font-size: 20px; font-weight: 900"
                        [ngClass]="{
                          'color-green': hdd.hddErasureresults === 'PASSED',
                          'color-orange': hdd.hddErasureresults === 'PARTIAL',
                          'color-red': hdd.hddErasureresults === 'FAILED',
                          'color-red-d': hdd.hddErasureresults === 'DESTROYED',
                          'color-red-r': hdd.hddErasureresults === 'REMOVED'
                        }"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure 3rd Party Verification</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hdd3rdpartyverifify{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.hdd3rdpartyverifify"
                        [readonly]="disabled"
                        style="font-size: 20px; font-weight: 900"
                        [ngClass]="{
                          'color-green': hdd.hdd3rdpartyverifify === 'PASSED',
                          'color-orange': hdd.hdd3rdpartyverifify === 'PARTIAL',
                          'color-red': hdd.hdd3rdpartyverifify === 'FAILED',
                          'color-red-d': hdd.hdd3rdpartyverifify === 'DESTROYED',
                          'color-red-r': hdd.hdd3rdpartyverifify === 'REMOVED'
                        }"
                      />
                    </div>
                  </div>
                  <div
                    class="row"
                    style="border-top: 1px solid #ccc"
                    *ngIf="hdd.isRemoved === '1' || hdd.isDestroyed === '1'"
                  >
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure Results (Before)</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="statusAnterior{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.statusAnterior"
                        readonly
                        style="font-size: 20px; font-weight: 900"
                        [ngClass]="{
                          'color-green': hdd.statusAnterior === 'PASSED',
                          'color-orange': hdd.statusAnterior === 'PARTIAL',
                          'color-red': hdd.statusAnterior === 'FAILED',
                          'color-red-d': hdd.statusAnterior === 'DESTROYED',
                          'color-red-r': hdd.statusAnterior === 'REMOVED'
                        }"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure Start Date</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddErasurestartdate{{ i + 1 }}"
                        class="form-control fctrl"
                        [readonly]="disabled"
                        [value]="hdd.hddErasurestartdate | date : 'MM/dd/yyyy'"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure Start Time</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddErasurestarttime{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.hddErasurestarttime"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure End Date</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddErasureenddate{{ i + 1 }}"
                        class="form-control fctrl"
                        [readonly]="disabled"
                        [value]="hdd.hddErasureenddate | date : 'MM/dd/yyyy'"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure End Time</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddErasureendtime{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.hddErasureendtime"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div
                    class="row"
                    style="border-top: 1px solid #ccc"
                    *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '1'"
                  >
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Destruction Date</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="destructionDate{{ i + 1 }}"
                        class="form-control fctrl"
                        [readonly]="disabled"
                        [value]="hdd.destructionDate | date : 'MM/dd/yyyy'"
                      />
                    </div>
                  </div>
                  <div
                    class="row"
                    style="border-top: 1px solid #ccc"
                    *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '1'"
                  >
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Destruction Status</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="destructionStatus{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.destructionStatus"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div
                    class="row"
                    style="border-top: 1px solid #ccc"
                    *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '1'"
                  >
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Representative</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="userRemoved{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.userRemoved"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div
                    class="row"
                    style="border-top: 1px solid #ccc"
                    *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '0'"
                  >
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Drive Removed On</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="removedDate{{ i + 1 }}"
                        class="form-control fctrl"
                        [readonly]="disabled"
                        [value]="hdd.removedDate | date : 'MM/dd/yyyy'"
                      />
                    </div>
                  </div>
                  <div
                    class="row"
                    style="border-top: 1px solid #ccc"
                    *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '0'"
                  >
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Representative</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="userRemoved{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.userRemoved"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <!--<div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">PO</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="hddPo{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddPo" [readonly] = "disabled">
                    </div>
                  </div>-->
                </div>
              </div>

              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngFor="let cpu of cpus; let i = index"
                >
                  <label class="bmd-label-floating">
                    <b> CPU #{{ i + 1 }} Information: </b>
                    <!--<button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(cpu, 'cpu')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>-->
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="cpuManufacturer{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="cpu.manufacturer"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="cpuModel{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="cpu.model"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="cpuSerialNumber{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="cpu.serialnumber"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Processor Speed</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="cpuField1{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="cpu.field1"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Processor Cores</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="cpuField2{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="cpu.field2"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Processor Type</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="cpuField3{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="cpu.field3"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngFor="let memory of memories; let i = index"
                >
                  <label class="bmd-label-floating">
                    <b> Memory #{{ i + 1 }} Information: </b>
                    <!--<button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(memory, 'memory')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>-->
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="memoryManufacturer{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="memory.manufacturer"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="memoryModel{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="memory.model"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="memorySerialNumber{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="memory.serialnumber"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Memory Size</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="memoryField1{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="memory.field1"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Memory Speed</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="memoryField2{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="memory.field2"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Memory Type</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="memoryType{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="memory.memorytype"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngFor="let t of testing; let i = index"
                >
                  <label class="bmd-label-floating">
                    <b> Testing #{{ i + 1 }} Information: </b>
                    <!--<button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(t, 'testing')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>-->
                  </label>
                  <!--<div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="testingSerialnumber{{i+1}}" class="form-control fctrl" [(ngModel)]="t.serialnumber" [readonly] = "disabled">
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Profile</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="testingProfile{{i+1}}" class="form-control fctrl" [(ngModel)]="t.profile" [readonly] = "disabled">
                    </div>
                  </div>-->
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">CPU</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="testingCPU{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="t.cpu"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Memory</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="testingMemory{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="t.memory"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="testingBattery{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="t.battery"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Missing Parts</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="testingField1{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="t.field1"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Case Condition</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="testingField2{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="t.field2"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Screen Condition</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="testingField3{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="t.field3"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Display Resolution</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="testingDisplayResolution{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="t.displayResolution"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Optical Device</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="testingOpticalDevice{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="t.opticalDevice"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngFor="let battery of batteries; let i = index"
                >
                  <label class="bmd-label-floating">
                    <b> Battery #{{ i + 1 }} Information: </b>
                    <!--<button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(battery, 'battery')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>-->
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="batteryManufacturer{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="battery.manufacturer"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="batteryModel{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="battery.model"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="batterySerialNumber{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="battery.serialnumber"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery Chemistry</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="batteryField1{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="battery.field1"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery Capacity</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="batteryField3{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="battery.field3"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery Full Charge</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="batteryField4{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="battery.field4"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery Life</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="batteryField5{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="battery.field5"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <!--<div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery Drain Test Results</p>
                    </div>
                    <div class="col-md-6 border">
                      <input type="text" name="batteryField7{{i+1}}" class="form-control fctrl" [(ngModel)]="battery.field7" [readonly] = "disabled">
                    </div>
                  </div>-->
                </div>
              </div>

              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngFor="let component of components; let i = index"
                >
                  <label class="bmd-label-floating">
                    <b> Component #{{ i + 1 }} Information: </b>
                    <!--<button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(component, 'component')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>-->
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="componentManufacturer{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="component.componentmanufacturer"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="componentModel{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="component.componentmodel"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="componentSerialNumber{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="component.componentserialnumber"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngFor="let network of networks; let i = index"
                >
                  <label class="bmd-label-floating">
                    <b> Network Adapter #{{ i + 1 }} Information: </b>
                    <!--<button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(network, 'network')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>-->
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Adapter</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="networkAdapter{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="network.networkadapter"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngFor="let v of video; let i = index"
                >
                  <label class="bmd-label-floating">
                    <b> Video Adapter #{{ i + 1 }} Information: </b>
                    <!--<button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="editMode()">
                      <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                    </button>
                    <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                      (click)="saveAttributes(v, 'video')" *ngIf="!disabled" >
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </button>-->
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Adapter</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="videoAdapter{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="v.videoadapter"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab *ngIf="bitrasershow">
            <ng-template mat-tab-label>
              <mat-icon style="margin-right: 8px">dataset</mat-icon>
              BitRaser Specs
            </ng-template>
              <div
                class="row scrollClass"
                *ngIf="bitrasershow"
                #childScrollElement
                (wheel)="stopPropagation($event)"
              >
              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngFor="let s of raserhardware; let i = index"
                >
                  <label class="bmd-label-floating">
                    <b> System Information: </b>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemManufacturer{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="s.manufacturer"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemModel{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="s.model"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemSerialNumber{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="s.systemSerial"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">SKU</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemSKU{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="s.skuNumber"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Processor Information</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemField2{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="s.field2"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Memory Information</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemField3{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="s.MemoryRam"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngFor="let hdd of raserdisk; let i = index"
                >
                  <label class="bmd-label-floating">
                    <b> HDD #{{ i + 1 }} Information: </b>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddModel{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.diskModel"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddSerialnumber{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.diskSerial"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Capacity</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddCapacity{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.diskSize"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Block Size</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddBlocksize{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.SectorSize"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Form Factor</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddFormfactor{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.Interface"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Device Type</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddDevicetype{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.MediaType"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Remap Sector</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddremappedSectors{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.remappedSectors"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure Results</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddErasureresults{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.ErasedResult"
                        [readonly]="disabled"
                        style="font-size: 20px; font-weight: 900"
                        [ngClass]="{
                          'color-green': hdd.ErasedResult === 'PASSED',
                          'color-orange': hdd.ErasedResult === 'PARTIAL',
                          'color-red': hdd.ErasedResult === 'FAILED',
                          'color-red-d': hdd.ErasedResult === 'DESTROYED',
                          'color-red-r': hdd.ErasedResult === 'REMOVED'
                        }"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure Start Date</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddErasurestartdate{{ i + 1 }}"
                        class="form-control fctrl"
                        [readonly]="disabled"
                        [value]="hdd.start | date : 'MM/dd/yyyy'"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure Start Time</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddErasurestarttime{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.startTime"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure End Date</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddErasureenddate{{ i + 1 }}"
                        class="form-control fctrl"
                        [readonly]="disabled"
                        [value]="hdd.end | date : 'MM/dd/yyyy'"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erasure End Time</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="hddErasureendtime{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="hdd.endTime"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngFor="let cpu of raserprocessor; let i = index"
                >
                  <label class="bmd-label-floating">
                    <b> CPU #{{ i + 1 }} Information: </b>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="cpuManufacturer{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="cpu.manufacturer"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="cpuModel{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="cpu.version_ModelName"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="cpuSerialNumber{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="cpu.processorID"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Processor Speed</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="cpuField1{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="cpu.currentClockSpeed"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Processor Cores</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="cpuField2{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="cpu.coreEnabled"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngFor="let memory of rasermemory; let i = index"
                >
                  <label class="bmd-label-floating">
                    <b> Memory #{{ i + 1 }} Information: </b>

                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="memoryManufacturer{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="memory.manufacturer"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>

                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Memory Size</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="memoryField1{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="memory.field1"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Memory Speed</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="memoryField2{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="memory.field2"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Memory Type</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="memoryType{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="memory.memorytype"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngFor="let t of raserhardwaretest; let i = index"
                >
                  <label class="bmd-label-floating">
                    <b> Testing #{{ i + 1 }} Information: </b>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">CPU</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="testingCPU{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="t.cpuStatus"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Memory</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="testingMemory{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="t.memoryStatus"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="testingBattery{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="t.batteryStatus"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Optical Device</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="testingOpticalDevice{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="t.opticalDriveStatus"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngFor="let battery of raserbatery; let i = index"
                >
                  <label class="bmd-label-floating">
                    <b> Battery #{{ i + 1 }} Information: </b>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="batteryManufacturer{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="battery.manufacturer"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="batteryModel{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="battery.model"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="batterySerialNumber{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="battery.serial"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery Chemistry</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="batteryField1{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="battery.type"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery Capacity</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="batteryField3{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="battery.current"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery Full Charge</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="batteryField4{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="battery.full"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery Health %</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="batteryhealth{{ i + 1 }}"
                        class="form-control fctrl"
                        [value]="battery.health + ' %'"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngFor="let network of rasernetwork; let i = index"
                >
                  <label class="bmd-label-floating">
                    <b> Network Adapter #{{ i + 1 }} Information: </b>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Adapter</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="networkAdapter{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="network.model"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngFor="let v of raservideo; let i = index"
                >
                  <label class="bmd-label-floating">
                    <b> Video Adapter #{{ i + 1 }} Information: </b>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Adapter</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="videoAdapter{{ i + 1 }}"
                        class="form-control fctrl"
                        [(ngModel)]="v.videoAdapter"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab  *ngIf="phonecheckshow">
            <ng-template mat-tab-label>
              <mat-icon style="margin-right: 8px">phone_iphone</mat-icon>
              PhoneCheck Specs
            </ng-template>
              <div
                class="row scrollClass"
                *ngIf="phonecheckshow"
                #childScrollElement
                (wheel)="stopPropagation($event)"
              >
              <div class="col-md-12">
                <div
                  class="card card-body border"
                 
                >
                  <label class="bmd-label-floating">
                    <b> Mobile Information: </b>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemManufacturer"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.manufacturer"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemModel"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.model"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemSerialNumber"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.serial"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model No</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemSKU"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.modelNo"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model #</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemField2"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.modelNumber"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Memory Information</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemField3"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.memory"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">OS</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="os"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.oS"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">IMEI</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="iMEI"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.iMEI"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Color</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="color"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.color"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Carrier</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="carrier"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.carrier"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Country Origin</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="contryOrigin"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.contryOrigin"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery Health %</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="battery"
                        [value]="phonecheckinfo.battery + ' %'"
                        class="form-control fctrl"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Device Lock</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="deviceLock"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.deviceLock"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">MDM</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="mDM"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.mDM"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Grade</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="grade"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.grade"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erased</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="erased"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.erased"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erased Type</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="erasedType"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.erasedType"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">PO#-Batch#</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="invoiceNo"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.invoiceNo"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Vendor Name</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="vendorName"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.vendorName"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Tester Name</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="testerName"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.testerName"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>  
 <!--              <div class="col-md-12">
                <div
                  class="card card-body border"
                  *ngIf="phonecheckinfo"
                >
                  <label class="bmd-label-floating">
                    <b> Parts: </b>
                  </label>
                <div
                  class="card card-body border"
                  *ngFor="let v of phonecheckpart; let i = index"
                >
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Name</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="name"
                        class="form-control fctrl"
                        [(ngModel)]="v.name"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Status</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="Status"
                        class="form-control fctrl"
                        [(ngModel)]="v.Status"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>
              </div>  -->
              <div class="col-md-12">
                <div class="card card-body border" *ngIf="phonecheckinfo">
                  <label class="bmd-label-floating">
                    <b>Parts:</b>
                  </label>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let v of phonecheckpart; let i = index">
                        <td>
                          <input
                            type="text"
                            name="name"
                            class="form-control fctrl"
                            [(ngModel)]="v.name"
                            [readonly]="disabled"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="Status"
                            class="form-control fctrl"
                            [(ngModel)]="v.Status"
                            [readonly]="disabled"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon style="margin-right: 8px">history_icon</mat-icon>
              Log History Inventory
            </ng-template>
            <table
              class="table mt-4"
              *ngIf="this.logs.length > 0 && !showSystemComments"
            >
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">Created At</th>
                  <th scope="col">Comment</th>
                  
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let log of logs">
                  <td>{{ log.id }}</td>
                  <td>{{ log.createdAt | date : "MM/dd/yyyy H:mm:ss" }}</td>
                  <td>{{ log.comment }}</td>
                </tr>
              </tbody>
            </table>
            <div *ngIf="showSystemComments">
              <div class="row">
                <div class="col-12">
                  <mat-form-field>
                    <textarea
                      name="systemComments"
                      rows="5"
                      matInput
                      placeholder="Inventory System Comments"
                      [(ngModel)]="systemComments"
                      readonly
                    ></textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div
              *ngIf="
                this.logs.length === 0 &&
                (systemComments === null || systemComments === '')
              "
              style="text-align: center"
            >
              <br /><br />
              <i
                class="fa fa-window-close-o"
                style="font-size: 80px"
                aria-hidden="true"
              ></i>
              <h3>No data</h3>
            </div>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="icon-container">
                <div *ngIf="internalComments" class="circle"></div>
                <mat-icon style="margin-right: 8px">comment</mat-icon>
              </div>
              Internal Comments
            </ng-template>
            <mat-form-field class="mt-4">
              <textarea
                name="internalComments"
                rows="5"
                matInput
                disabled
                placeholder="Internal Comments"
                [(ngModel)]="internalComments"
                readonly
              ></textarea>
            </mat-form-field>
          </mat-tab>
        </mat-tab-group>
      </div>
      <!-- <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary"
          *ngIf="systemComments !== null && systemComments !== ''"
          (click)="showSystemComments = !showSystemComments"
        >
          {{
            showSystemComments ? "Hide System Comments" : "Show System Comments"
          }}
        </button>
      </div> -->
    </div>
  </div>
</div>